(() => {
  document.querySelectorAll('[data-qg-ask]').forEach(ask => {
    const form = ask.querySelector('form'), input = form.elements.message;
    const status = ask.querySelector('[role="status"]'), log = ask.querySelector('[role="log"]');
    const submit = form.querySelector('[type="submit"]'), voice = ask.querySelector('[data-qg-voice]');
    const endpoint = ask.dataset.endpoint;
    const history = [];
    const serverVoice = window.QoolalaVoice?.attach({ask, input, status, voice, submit});
    const Recognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    let recognition;
    if (!serverVoice && Recognition && endpoint) {
      voice.hidden = false;
      const note = ask.querySelector('[data-qg-voice-note]');
      note.textContent = 'Voice uses your browser’s speech service. Review what it heard before asking.'; note.hidden = false;
      recognition = new Recognition(); recognition.lang = 'en-GB'; recognition.interimResults = false;
      recognition.onresult = event => { input.value = event.results[0][0].transcript; status.textContent = 'Check your question, then press Ask.'; input.focus(); };
      recognition.onend = () => { voice.setAttribute('aria-pressed', 'false'); voice.textContent = 'Speak'; };
      recognition.onerror = () => { status.textContent = 'Voice input is unavailable. You can type your question instead.'; };
      voice.onclick = () => {
        if (voice.getAttribute('aria-pressed') === 'true') { recognition.stop(); return; }
        try { recognition.start(); voice.setAttribute('aria-pressed', 'true'); voice.textContent = 'Stop'; status.textContent = 'Listening. Your browser handles speech recognition.'; }
        catch { status.textContent = 'Voice input could not start. Please type your question.'; }
      };
    }
    const BAG = '<svg class="qg-i qg-i-bag" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 8h14l-1 12H6zM9 8V6.5a3 3 0 0 1 6 0V8"/></svg>';
    const ARROW = '<svg class="qg-i qg-i-bag" viewBox="0 0 24 24" aria-hidden="true"><path d="M7 17L17 7M9 7h8v8"/></svg>';
    function say(who, text) {
      const p = document.createElement('p'), label = document.createElement('strong');
      p.dataset.speaker = who === 'You' ? 'user' : 'agent'; label.textContent = `${who}: `; p.append(label, document.createTextNode(text)); log.append(p);
      log.scrollTop = log.scrollHeight;
    }
    form.addEventListener('submit', async event => {
      event.preventDefault();
      const message = input.value.trim(); if (!message || submit.disabled) return;
      // A page with a discovery feed may shape it from the question (it sets detail.note to say so).
      const detail = {message, note: ''};
      ask.dispatchEvent(new CustomEvent('qoolala:ask', {bubbles: true, detail}));
      if (!endpoint) {
        status.textContent = 'Ask Qoolala is not connected yet. Explore the feed or choose a category below.';
        if (detail.note) { say('You', message); say('Qoolala', detail.note); input.value = ''; }
        return;
      }
      serverVoice?.cancel(false); recognition?.stop(); submit.disabled = true; status.textContent = 'Finding relevant picks…';
      say('You', message);
      const controller = new AbortController(), timeout = setTimeout(() => controller.abort(), 25000);
      try {
        const response = await fetch(endpoint, {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({message, history: history.slice(-6)}), signal: controller.signal});
        if (!response.ok) throw new Error('assistant unavailable');
        const reply = await response.json();
        if (typeof reply.answer !== 'string') throw new Error('invalid answer');
        say('Qoolala', reply.answer);
        const results = document.createElement('div'); results.className = 'qg-ask-results';
        for (const item of (reply.items || []).slice(0, 8)) {
          let url; try { url = new URL(item.url, location.origin); } catch { continue; }
          if (url.protocol !== 'https:') continue;
          const link = document.createElement('a'); link.href = url.href;
          const external = item.kind === 'editorial';
          const disclosure = external ? (item.relationship === 'affiliate' ? 'External affiliate link' : item.relationship === 'sponsored' ? 'Sponsored external find' : 'External find') : 'Shop Qoolala';
          // Constant icons only: a bag marks a find you can buy here, an arrow marks one that leaves the site.
          link.insertAdjacentHTML('afterbegin', external ? ARROW : BAG);
          const name = document.createElement('span'); name.textContent = item.title;
          const note = document.createElement('span'); note.className = external ? 'qg-ask-note' : 'qg-visually-hidden'; note.textContent = ` · ${disclosure}`;
          link.append(name, note);
          if (url.origin !== location.origin) { link.target = '_blank'; link.rel = 'noopener noreferrer'; }
          results.append(link);
        }
        log.append(results); history.push({role: 'user', content: message}, {role: 'assistant', content: reply.answer});
        if (detail.note) say('Qoolala', detail.note);
        ask.dispatchEvent(new CustomEvent('qoolala:ask-results', {bubbles: true, detail: {results}}));
        input.value = ''; status.textContent = 'Ask a follow-up to narrow it down.';
      } catch {
        status.textContent = 'Ask Qoolala could not respond. Please try again, or explore the feed.';
        if (detail.note) say('Qoolala', detail.note);
      }
      finally { clearTimeout(timeout); submit.disabled = false; }
    });
  });
})();
